export default "__VITE_ASSET__MdXwJqMG__"